import React, { Component, Fragment } from "react";

import Tabcha from "./Tabcha";
import Boxer from "./Boxer.js";
import CustomizedSwitches from "./Switch";
import Typography from "@material-ui/core/Typography";
import Container from "@material-ui/core/Container";
import CustomizedProgressBars from "./spinner";
import Box from "@material-ui/core/Box";
import "./item.css";
import IconButton from "@material-ui/core/IconButton";
import { connect } from "react-redux";
import Grid from "@material-ui/core/Grid";
import CloseIcon from "@material-ui/icons/KeyboardBackspace";
import Boxer2 from "./Boxer2";
import GoBack from "./goBackcnf";
import * as handler from "../Actions/main";
//import { typography } from "material-ui/styles";
// import Beforeunload from 'react-beforeunload';
class Menu extends Component {
  componentWillUnmount() {
    console.log("ummount");
    this.props.reset();
  }

  // showSpinner = bool => {
  //   console.log("ja k mar jas" + bool);
  //   this.setState({
  //     isSpinner: bool
  //   });
  // };

  componentDidMount() {
    console.log("did mount");
    this.props.resetOrder();

    if (this.props.status === false) {
      this.props.fetchItem(
        this.props.match.params.trainNO,
        this.props.match.params.doj,
        this.props.match.params.outletId,
        this.props.match.params.provider,
        this.props.match.params.stationCode
      );
    }
  }

  back = () => {
    this.props.history.goBack();
  };

  render() {
    let result;
    // console.log(this.props);
    if (this.props.isLoading === false) {
      if (this.props.error === false) {
        result = (
          <Fragment>
            <Grid
              container
              style={{
                backgroundColor: "#45A04A",
                position: "fixed",
                top: 0,
                right: 0,
                left: 0,
                width: "100%",
                zIndex: 100,
                height: "15%",
                margin: "0px"
              }}
              spacing={2}
            >
              <Grid item xs={2} style={{ paddingRight: "0px" }}>
                {this.props.counter > 0 ? (
                  <GoBack back={this.back} />
                ) : (
                  <IconButton
                    edge="start"
                    style={{
                      color: "white",
                      paddingTop: "5px"
                    }}
                    onClick={this.back}
                    aria-label="Close"
                  >
                    <CloseIcon />
                  </IconButton>
                )}
              </Grid>

              <Grid item xs={8} style={{ paddingLeft: "0px" }}>
                <Typography style={{ fontWeight: "bold", color: "white" }}>
                  <span
                    style={{
                      fontSize: "16px",
                      overflow: "hidden",
                      textOverflow: "ellipsis"
                    }}
                  >
                    {" "}
                    {this.props.match.params.outletName}
                  </span>
                </Typography>
                <Typography style={{ color: "white" }}>
                  <span
                    style={{
                      fontSize: "12px",
                      overflow: "hidden",
                      textOverflow: "ellipsis"
                    }}
                  >
                    {this.props.match.params.StaN +
                      " " +
                      this.props.match.params.sta}
                  </span>
                </Typography>
              </Grid>

              <Grid item xs={2} style={{ paddingTop: 10, paddingLeft: 0 }}>
                {this.props.counter > 0 ? <Boxer /> : null}
              </Grid>
            </Grid>

            <Grid
              container
              style={{
                position: "fixed",
                top: 60,
                width: "100%",
                backgroundColor: "#FFFFFF",
                zIndex: 100,
                height: "10%"
              }}
            >
              <Grid
                item
                xs={6}
                style={{ paddingTop: "7px", paddingLeft: "5px" }}
              >
                Minimum Order ₹{this.props.match.params.minOrder}
              </Grid>
              {/* <Grid item xs={3}>
          </Grid> */}
              <Grid item xs={6}>
                <Box
                  display="flex"
                  flexDirection="row"
                  style={{ float: "right", marginRight: 2 }}
                >
                  <Box style={{ paddingTop: "8px" }}>Veg Only</Box>
                  <Box>
                    <CustomizedSwitches />
                  </Box>
                </Box>
              </Grid>
            </Grid>
            {this.props.counter > 0 ? (
              <Grid
                container
                style={{
                  position: "fixed",
                  margin: "0px",
                  backgroundColor: "white",
                  bottom: 0,
                  zIndex: 100,
                  width: "100%",
                  height: "10%",
                  boxShadow:
                    "0px 2px 4px -1px rgba(0,0,0,0.2), 0px 4px 5px 0px rgba(0,0,0,0.14), 0px 1px 10px 0px rgba(0,0,0,0.12)"
                }}
                alignItems="center"
              >
                <Grid item xs={1} />
                <Grid item xs={5}>
                  <Typography style={{ fontWeight: "bold" }}>
                    {this.props.counter +
                      " Items | ₹" +
                      this.props.totalPrice.toFixed(2)}
                  </Typography>
                </Grid>
                <Grid item xs={6}>
                  <Boxer2 />
                </Grid>
              </Grid>
            ) : null}

            <Tabcha />
          </Fragment>
        );
      } else
        result = (
          <Container style={{ marginTop: "50%", textAlign: "center" }}>
            <span style={{ fontSize: "14px" }}> Failed while fetching </span>
          </Container>
        );
    } else {
      result = (
        <Container>
          <Typography
            variant="h5"
            color="textSecondary"
            align="center"
            style={{ marginBottom: 150 }}
          />
          <div style={{ textAlign: "center", marginBottom: 5 }}>
            <CustomizedProgressBars />
          </div>
          <Typography variant="h5" color="textSecondary" align="center">
            Fetching Menu Items
          </Typography>
        </Container>
      );
    }

    return result;
  }
}

const mapDispatchToProps = dispatch => {
  return {
    reset: () => dispatch(handler.reset()),
    resetOrder: () => dispatch(handler.resetRecords()),
    fetchItem: (trainNO, doj, outletId, provider, stationCode) =>
      dispatch(handler.initItem(trainNO, doj, outletId, provider, stationCode))
  };
};

const mapStateToProps = state => {
  return {
    counter: state.menuR.counter,
    error: state.menuR.error,
    totalPrice: state.menuR.totalPrice,
    isLoading: state.menuR.isLoading,
    status: state.menuR.status
  };
};
export default connect(
  mapStateToProps,
  mapDispatchToProps
)(Menu);
